import {PrimaryButton, Modal} from 'components';
import React from 'react';

function GetPlanModal({open, setOpen, plan, baseColor}) {
  if (!plan) return null;

  const staticDate = '12-08-2022';

  const handleProceed = () => {
    console.log(`Proceeding with ${plan.name} plan`);
    setOpen(false);
  };

  return (
    <Modal
      show={open}
      onClose={() => setOpen(false)}
      modalTitle={`Get the ${plan.name.toLowerCase()} plan`}
      extraModalClasses="max-w-[528px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
    >
      <div className="p-6">
        <div className="flex text-sm mb-7 gap-[85px]">
          <div className="text-start">
            <p className="text-[#868C98] mb-1 text-small">Invoice Date</p>
            <p className="text-[#080917] text-sm">{staticDate}</p>
          </div>
          <div className="text-start">
            <p className="text-[#868C98] mb-1 text-small">Next Billing Date</p>
            <p className="text-[#080917] text-sm">{staticDate}</p>
          </div>
        </div>

        <div className="pb-2">
          <div className="flex justify-between text-small font-medium text-[#868C98] pb-2 border-b border-[#EBEBEB]">
            <span className="w-1/3 text-left">Plan</span>
            <span className="w-1/3 text-left">Events Quota</span>
            <span className="w-1/3 text-right">Price</span>
          </div>
          <div className="flex justify-between text-small font-medium text-[#4F555F] py-2">
            <span className="w-1/3 text-left">{plan.name}</span>
            <span className="w-1/3 text-left">{plan.quota}</span>
            <span className="w-1/3 text-right">{plan.priceString}</span>
          </div>
        </div>

        <div className="flex flex-col items-end">
          <div className="w-full text-sm">
            <div className="w-full mb-[1px] border-b border-[#EBEBEB]">
              <div className="max-w-[180px] ml-auto">
                <div className="flex justify-between py-1 mb-2 text-xs">
                  <span className="text-[#868C98] font-medium">Subtotal</span>
                  <span className="text-black font-medium">
                    {plan.subtotal}
                  </span>
                </div>
                <div className="flex justify-between py-1 text-xs mb-2">
                  <span className="text-[#868C98] font-medium">VAT (10%)</span>
                  <span className="text-black font-medium">{plan.vat}</span>
                </div>
              </div>
            </div>

            <div className="flex justify-between py-3 border-y border-[#EBEBEB] text-small text-black font-semibold">
              <div className="flex items-center gap-[90px] justify-end w-full">
                <span>Total</span>
                <span>{plan.total}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full px-6 py-[14px] bg-[#F9F9F9] border-[0.5px] flex gap-4 border-transparent border-t-[#EFEFEF]">
        <PrimaryButton
          buttonText="Proceed"
          className="w-full !h-10"
          onClick={handleProceed}
        />
      </div>
    </Modal>
  );
}

export default GetPlanModal;
